import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import omit from 'lodash/omit';
import AssignModal from './components/AssignModal';
import { getAssignedISAInfo, showToastNotification } from './utils';

import PopOver from 'chameleon/ui-stack/ui/base/popover';
import Button from 'chameleon/ui-stack/ui/base/button';

class AssignItem extends PureComponent {
  static displayName = 'AssignItem';

  static propTypes = {
    beforeModalOpen: PropTypes.func,
    /**
     * PopOver clickable button
     * */
    button: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array,
      PropTypes.object,
    ]),
    closePopover: PropTypes.bool,
    forcePopupClose: PropTypes.bool,
    onPopOverToggle: PropTypes.func,
    className: PropTypes.string,
    buttonClassName: PropTypes.string,
    groups: PropTypes.array,
    /**
     * The title of the item.
     * */
    itemTitle: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.number,
    ]),
    itemId: PropTypes.number.isRequired,
    hideSecureToggle: PropTypes.bool,
    onAssign: PropTypes.func,
    disabled: PropTypes.bool,
    notificationText: PropTypes.string,
    isFinalExam: PropTypes.bool,
    isPilot: PropTypes.bool,
    isSPP: PropTypes.bool,
    acceptedPracticeExamToc: PropTypes.bool,
    me: PropTypes.object,
    subjectInfo: PropTypes.object,
    onAssignRedirect: PropTypes.bool,
    role: PropTypes.string,
    buttonRef: PropTypes.shape({
      current: PropTypes.oneOfType([
        PropTypes.instanceOf(Element),
        PropTypes.symbol,
      ]),
    }),
    isPPC: PropTypes.bool,
    useNewAssignModalFlag: PropTypes.bool,
    assessment: PropTypes.object,
    isLC: PropTypes.bool,
  };

  static defaultProps = {
    assessment: {},
    beforeModalOpen: null,
    disabled: false,
    forcePopupClose: false,
    closePopover: false,
    notificationText: '',
    hideSecureToggle: false,
    isFinalExam: false,
    isPilot: false,
    isSPP: false,
    acceptedPracticeExamToc: false,
    isSampleQuiz: false,
    button: undefined,
    onPopOverToggle: () => {},
    className: '',
    buttonClassName: '',
    groups: [],
    itemTitle: '',
    onAssign: () => {},
    subjectInfo: {},
    me: {},
    isLC: false,
    // https://academicmerit.atlassian.net/browse/FY-17431 set to false by default
    onAssignRedirect: false,
    role: 'button',
    buttonRef: { current: Fragment },
    sendTelemetryEvent: () => {},
    isPPC: false,
    useNewAssignModalFlag: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      displayAssignModal: false,
    };

    this.onAssign = this.onAssign.bind(this);
    this.onMultiSettingsAssign = this.onMultiSettingsAssign.bind(this);
    this.handleAssignModal = this.handleAssignModal.bind(this);
    this.toggleAssignModal = this.toggleAssignModal.bind(this);
  }

  onAssign(
    assignmentsResponse,
    formAssignees,
    formStudents,
    availableSections,
  ) {
    const { isSingleISA, isMultipleAssignWithISA, className, totalAssignees } =
      getAssignedISAInfo(formAssignees, formStudents, availableSections);
    const subjectId = this.props.router.params.subject;
    showToastNotification(
      assignmentsResponse,
      isSingleISA,
      isMultipleAssignWithISA,
      className,
      totalAssignees,
      formStudents,
      subjectId,
    );

    const { onAssign } = this.props;
    onAssign(
      assignmentsResponse,
      totalAssignees,
      isSingleISA,
      isMultipleAssignWithISA,
    );

    this.toggleAssignModal();
  }

  onMultiSettingsAssign(assignmentsResponse) {
    this.props.onAssign(assignmentsResponse);
  }

  handleAssignModal(e) {
    const { beforeModalOpen, sendTelemetryEvent } = this.props;
    sendTelemetryEvent && sendTelemetryEvent();
    if (beforeModalOpen) {
      beforeModalOpen(() => this.toggleAssignModal(e));
    } else {
      this.toggleAssignModal(e);
    }
  }

  toggleAssignModal(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState(({ displayAssignModal }) => ({
      displayAssignModal: !displayAssignModal,
    }));
  }

  closeAssignModal = (e) => {
    this.toggleAssignModal(e);
    if (this.props.onClose) this.props.onClose();
  };

  render() {
    const {
      button,
      disabled,
      isAdminOrCoordinator,
      isSampleQuiz,
      buttonRef,
      useNewAssignModalFlag,
      isLC,
    } = this.props;
    let isDisabled = disabled || !this.props.groups.length;

    /**
     * Even if the user has no groups
     * allow admin/coordinator user type to see the control
     * */
    if (isAdminOrCoordinator) {
      isDisabled = false;
    }

    const modalButton =
      button && typeof button !== 'string' ? (
        React.cloneElement(button, {
          onClick: this.handleAssignModal,
          ref: buttonRef,
        })
      ) : (
        <Button
          isNaked
          isLink
          ref={buttonRef}
          aria-label="Assign"
          disabled={isDisabled}
          onClick={this.handleAssignModal}
        >
          Assign
        </Button>
      );
    const { displayAssignModal } = this.state;

    return (
      <Fragment>
        {isSampleQuiz ? (
          <PopOver
            size="medium"
            trigger={
              <Button
                accessibility={{
                  label: 'Assign',
                }}
              >
                Assign
              </Button>
            }
          >
            <div className="mock">
              This is a sample Learning Checkpoint that cannot be assigned to
              students.
            </div>
          </PopOver>
        ) : (
          modalButton
        )}
        {displayAssignModal && (
          <AssignModal
            key="modal"
            {...omit(this.props, ['beforeModalOpen', 'assignment'])}
            onAssignModalClose={this.closeAssignModal}
            assessment={{
              is_learning_checkpoint: isLC,
            }}
            onAssign={
              useNewAssignModalFlag ? this.onMultiSettingsAssign : this.onAssign
            }
          />
        )}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    useNewAssignModalFlag: state.featureFlag.new_assign_modal,
  };
}

export default withRouter(connect(mapStateToProps)(AssignItem));
